import { Hooks } from 'react-table'

const DMS_PATH = '/searchdetails/customcard/vehicle-dealer'

const tableHooks = <D extends object>(hooks: Hooks<D>): void => {
    const { pathname } = window.location

    if (pathname.includes(DMS_PATH)) {
        hooks.visibleColumns.push((columns) => [...columns])
    }
}

export default tableHooks
